import React, {Component} from 'react';
import './fixedContact.css';
import {Link} from 'react-router-dom';
import {Container,Modal, ModalHeader,ModalFooter,Row,Col,ModalBody} from 'reactstrap';
import handleValidation from '../Validation';


class FixedContact extends Component{
    constructor(props){
        super(props);
        this.state = {
            //scrollPos: window.pageYOffset,
            visible: false,
            modal: false,
        }

        this.updateScroll = this.updateScroll.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    componentDidMount(){
        window.addEventListener('scroll', this.updateScroll);
    }

    componentWillUnmount(){
        window.removeEventListener('scroll',this.updateScroll);
    }

    updateScroll = () =>{
        const currentScrollPos = window.pageYOffset;
        const visible = currentScrollPos > 600;
        this.setState({
            //scrollPos: currentScrollPos,
            visible: visible,
            firstName: '',
            lastName: '',
            email: '',
            phoneNumber: '',
            subject: '',
            textArea: ''
        });
    }

    toggle() {
        this.setState(prevState => ({
          modal: !prevState.modal
        }));
      }

      submitDetails = event => {
        debugger;
    
        let formData = {
          first_name: this.refs.first_name.value,
          last_name: this.refs.last_name.value,
          contact: this.refs.contact.value,
          email: this.refs.email.value
        };
        let errors = handleValidation(formData);
        this.setState({ errors: errors });
        if (errors["valid"] === true) {
          document.getElementById("contactUs").action =
            "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8";
          document.getElementById("contactUs").method = "POST";
        } else {
          this.setState({ errorsdiv: true });
          event.preventDefault();
        }
      };

    render(){
        return (
            <div id='scrolled' 
                className={`floating-side-btn ${this.state.visible ? 'display-flex' : 'display-none'}`}
                onClick={this.toggle}
            >
                {/* <Link to='/contact-us' id='fc-link'> */}
                    <h3 className='d-none d-sm-block mb-0'>Contact Us</h3>
                    <img className='d-block d-sm-none' src={require('../images/email-icon-v2.svg')} />
                {/* </Link> */}

                {/* MODAL BELOW THIS */}

                <Modal
                isOpen={this.state.modal}
                toggle={this.toggle}
                style={{maxWidth: '750px'}}
                >
                <ModalHeader style={{backgroundColor:"#26272d", color:"white"}} toggle={this.toggle}>Contact Us</ModalHeader>
                <ModalBody className='dark-background' >
                    <Row className='justify-content-center d-none d-sm-block'>
                        <Col xs={{ size: 12 }}>
                        <div  className='px-sm-5 pt-sm-5'>
                        <p>
                            Thank you for reaching out!
                            <br /> <br />
                            If you have any questions about our courses or the company, please feel free to contact us below or email us at info@itslighthouse.com We’re happy to help!
                        </p>
                        </div>
                        
                        </Col>
                    </Row>

                    <Row className='justify-content-center'>
                        <Col xs={{ size: 12 }}>
                        <div className='p-sm-5'>
                            <form
                            id="contactUs"
                            action=""
                            method=""
                                onSubmit={this.submitDetails.bind(this)}
                            >
                            <input type="hidden" name="lead_source" value="Website" />
                                <input type="hidden" name="oid" value="00D3i000000GUvA" />
                                <input
                                type="hidden"
                                name="00N3i00000Bm5C9"
                                value="Contact_us_website_v1"
                                />
                                <input
                                type="hidden"
                                name="retURL"
                                value="https://atlighthouse.com/thank-you"
                                />
                            <Row>
                                <Col>
                                <label htmlFor="first_name" className="apply-now-labels">
                                    First Name<p className="required-symbol">{"*"}</p>
                                </label>
                                <input
                                    id="first_name"
                                    maxLength="40"
                                    name="first_name"
                                    size="20"
                                    type="text"
                                    ref="first_name"
                                    className="apply-now-inputs form-control"
                                    placeholder="First Name"
                                />
                                {this.state.errorsdiv === true ? (
                                    <span className="error">
                                        {this.state.errors["first_name"]}
                                    </span>
                                    ) : (
                                    ""
                                    )}
                                <br />
                                </Col>
                                <Col>
                                <label htmlFor="last_name" className="apply-now-labels">
                                    Last Name<p className="required-symbol">{"*"}</p>
                                </label>
                                <input
                                    id="last_name"
                                    maxLength="80"
                                    name="last_name"
                                    size="20"
                                    type="text"
                                    ref="last_name"
                                    className="apply-now-inputs form-control"
                                    placeholder="Last Name"
                                />
                                {this.state.errorsdiv === true ? (
                                    <span className="error">
                                        {this.state.errors["last_name"]}
                                    </span>
                                    ) : (
                                    ""
                                    )}
                                <br />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={{size: 12}}>
                                <label htmlFor="email" className="apply-now-labels">
                                    Email<p className="required-symbol">{"*"}</p>
                                </label>
                                <input
                                    id="email"
                                    maxlength="80"
                                    name="email"
                                    size="20"
                                    type="text"
                                    ref="email"
                                    className="apply-now-inputs form-control"
                                    placeholder="Email"
                                />
                                {this.state.errorsdiv === true ? (
                                    <span className="error">
                                        {this.state.errors["email"]}
                                    </span>
                                    ) : (
                                    ""
                                    )}
                                <br />
                                </Col>
                                <Col xs={{size:12}}>
                                <label htmlFor="contact" className="apply-now-labels">
                                    Phone Number<p className="required-symbol">{"*"}</p>
                                </label>
                                <input
                                    id="contact"
                                    maxlength="40"
                                    name="phone"
                                    size="20"
                                    type="text"
                                    ref="contact"
                                    className="apply-now-inputs form-control"
                                    placeholder="Phone Number "
                                />
                                {this.state.errorsdiv === true ? (
                                    <span className="error">
                                        {this.state.errors["contact"]}
                                    </span>
                                    ) : (
                                    ""
                                    )}
                                <br />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                <label className="apply-now-labels" for="exampleText">
                                    Message
                                </label>
                                <textarea
                                    id="00N3i00000Bklln"
                                    name="00N3i00000Bklln"
                                    rows="8"
                                    type="text"
                                    wrap="soft"
                                    className="apply-now-inputs form-control"
                                    placeholder="I'm reaching out for..."
                                ></textarea>
                                <br />
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                <input
                                    type="submit"
                                    name="submit"
                                    className="courses-button btn btn-secondary"
                                />
                                </Col>
                            </Row>
                            </form>

                            <Row>
                            <Col>
                                <p className="privacy-terms1">
                                <i>
                                    By providing your email, you agree to our{" "}
                                    <u>
                                    <Link style={{ color: "white" }} to="/privacy-policy">
                                        privacy policy
                                    </Link>
                                    </u>{" "}
                                    and{" "}
                                    <u>
                                    <Link
                                    style={{ color: "white" }}
                                        to="/terms-and-conditions"
                                    >
                                    terms and conditions
                                    </Link>
                                    </u>
                                </i>
                                .
                                </p>
                            </Col>
                            </Row>
                        </div>
                        </Col>
                    </Row>
                </ModalBody>
                </Modal>
            </div>
        );
    }

}

export default FixedContact;